
import { Component, Input } from '@angular/core';
import { Product } from '@spartacus/core';
import { ProductPriceModule } from '../../../product-price/product-price.module';
import { Router, RouterModule } from '@angular/router';
import { of } from 'rxjs';
import { ProductComparatorService } from '../../core/product-comparator.service';
import { PRODUCT_COMPARATOR_TYPE } from '../../core/product-comparator.model';
import { ProductCardComponent } from '../../../product-card/product-card.component';
import { TARGET_TYPE } from '../../../../../../core/models/link.model';

@Component({
  selector: 'product-comparator-item',
  standalone: true,
  imports: [RouterModule, ProductPriceModule, ProductCardComponent],
  templateUrl: './product-comparator-item.component.html',
  styleUrl: './product-comparator-item.component.scss',
})
export class ProductComparatorItemComponent {
  PRODUCT_COMPARATOR_TYPE = PRODUCT_COMPARATOR_TYPE;
  TARGET_TYPE = TARGET_TYPE;

  @Input() product!: Product;
  @Input() isOriginal = false;
  product$ = of(this.product);
  currentType = this.productComparatorService.getCurrentComparationType();

  constructor(
    private router: Router,
    private productComparatorService: ProductComparatorService,
  ) {}

  convertToObservable(product: Product) {
    return of(product);
  }

  remove(product: Product) {
    this.redirectWithoutCode(product.code!);
  }

  redirectWithoutCode(code: string): void {
    const currentUrl = this.router.url;
    const [baseUrl, queryString] = currentUrl.split('?');
    const queryParams = new URLSearchParams(queryString);
    const productCodes = queryParams.get('pids')?.split(',') || [];
    const updatedCodes = productCodes.filter(pid => pid !== code);

    if (updatedCodes.length > 0) {
      queryParams.set('pids', updatedCodes.join(','));
    } else {
      queryParams.delete('pids');
    }

    const newUrl = `${baseUrl}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;

    this.router.navigateByUrl(newUrl);
  }
}
